'use client';

import { useEffect, useState } from 'react';

import YouTubePlayerFallbackImg from './YouTubePlayerFallbackImg';
import { useYouTubePlayerControls, useYouTubePlayerLoader } from './hooks';
import { YouTubeVideoEmbedProps } from './types';

const YouTubeVideoEmbed = (props: YouTubeVideoEmbedProps) => {
	const { autoplay = false, controls = true, pause, className, fallbackImg } = props;

	const [container, setContainer] = useState<HTMLDivElement | null>(null);
	const [showFallbackImage, setShowFallbackImage] = useState(Boolean(fallbackImg) && !autoplay);

	const player = useYouTubePlayerLoader({ ...props, container });

	const { handlePlayVideo, handlePauseVideo } = useYouTubePlayerControls(
		player,
		setShowFallbackImage,
	);

	useEffect(() => {
		if (!player) return;

		if (pause) {
			handlePauseVideo();
			return;
		}

		if (autoplay) {
			handlePlayVideo();
		}
	}, [player, pause, autoplay, handlePlayVideo, handlePauseVideo]);

	const ref = (containerRef: HTMLDivElement) => {
		setContainer(containerRef);
	};

	return (
		<div className={className}>
			<YouTubePlayerFallbackImg
				showFallbackImage={showFallbackImage}
				playVideo={player && controls ? handlePlayVideo : undefined}
				fallbackImg={fallbackImg}
				className="h-full w-full"
			>
				<div ref={ref} />
			</YouTubePlayerFallbackImg>
		</div>
	);
};

YouTubeVideoEmbed.displayName = 'YouTubePlayer';

export default YouTubeVideoEmbed;
